import { render, staticRenderFns } from "./AbastecimentoListModal.vue?vue&type=template&id=0ecd2e5d&scoped=true"
import script from "./AbastecimentoListModal.vue?vue&type=script&lang=js"
export * from "./AbastecimentoListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd2e5d",
  null
  
)

export default component.exports